import React from "react";
import { RaisedButton, TextField } from "material-ui";
import { Link } from "react-router";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonActions from "../../actions/PersonActions";
import PersonStore from "../../stores/PersonStore";

@connectToStores
class LoginInline extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: null,
      password: null
    };

    this._login = this._login.bind(this);
  }

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  _login() {
    PersonActions.login(
      this.state.username || this.props.defaultUsername,
      this.state.password
    );
  }

  getStyles() {
    return {
      form: {
        minWidth: "70%",
        width: 200,
        margin: "0 auto"
      },
      field: {
        width: "100%"
      },
      actions: {
        marginTop: 10,
        textAlign: "center"
      },
      error: {
        marginTop: 5,
        textAlign: "center",
        color: "#FF4136"
      },
      forgot: {
        marginTop: 20,
        textAlign: "center"
      }
    };
  }

  render() {
    let styles = this.getStyles();

    return (
      <form style={Object.assign({}, styles.form, this.props.style)}>
        <div>
          <TextField
            hintText="Email address"
            value={
              this.state.username !== null
                ? this.state.username
                : this.props.defaultUsername || ""
            }
            onChange={e => this.setState({ username: e.target.value })}
            style={styles.field}
            disabled={this.props.loginInProgress}
          />
        </div>
        <div>
          <TextField
            hintText="Password"
            disabled={this.props.loginInProgress}
            value={this.state.password || ""}
            onChange={e => this.setState({ password: e.target.value })}
            style={styles.field}
            onKeyDown={e => {
              if (e.keyCode === 13) this._login();
            }}
            autoFocus={!!this.props.defaultUsername}
            type="password"
          />
        </div>
        {this.props.loginErrorMessage ? (
          <div style={styles.error}>{this.props.loginErrorMessage}</div>
        ) : null}
        <div style={styles.actions}>
          <RaisedButton
            label={this.props.loginInProgress ? "Logging in..." : "Login"}
            disabled={this.props.loginInProgress}
            primary={true}
            onClick={this._login}
          />
        </div>
        <div style={styles.forgot}>
          <Link to="/forgot">Forgot password?</Link>
        </div>
      </form>
    );
  }
}

export default LoginInline;



// WEBPACK FOOTER //
// ./src/app/components/partials/login-inline.jsx